module.exports = __webpack_public_path__ + "static/media/makeover.6486b2bb.jpg";